import React, { useEffect, useState } from 'react';
import { apiUrl } from '../apiUrl';

// Dashboard callers provide route paths without the API prefix; keep the
// prefix centralized so protected media always reaches /api/files exactly once.
export const protectedMediaUrl = (endpoint: string) =>
  apiUrl(endpoint.startsWith('/api/') ? endpoint : `/api${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`);

export const useAuthenticatedMedia = (endpoint?: string) => {
  const [url, setUrl] = useState<string>();
  useEffect(() => {
    let active = true;
    let objectUrl: string | undefined;
    if (!endpoint) { setUrl(undefined); return () => undefined; }
    const token = localStorage.getItem('token');
    fetch(protectedMediaUrl(endpoint), { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then((response) => response.ok ? response.blob() : Promise.reject(new Error('Private file unavailable')))
      .then((blob) => { objectUrl = URL.createObjectURL(blob); if (active) setUrl(objectUrl); })
      .catch(() => { if (active) setUrl(undefined); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [endpoint]);
  return url;
};

export const AuthenticatedMedia: React.FC<{ endpoint: string; alt: string; className?: string; style?: React.CSSProperties; fallback?: React.ReactNode }> = ({ endpoint, alt, className, style, fallback }) => {
  const url = useAuthenticatedMedia(endpoint);
  return url ? <img src={url} alt={alt} className={className} style={style} /> : <>{fallback || null}</>;
};

export const openAuthenticatedMedia = async (endpoint: string) => {
  const token = localStorage.getItem('token');
  const response = await fetch(protectedMediaUrl(endpoint), { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!response.ok) throw new Error('Private file unavailable');
  const url = URL.createObjectURL(await response.blob());
  window.open(url, '_blank', 'noopener,noreferrer');
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
};
